export const awsFileUploadMixin = {
  methods: {
    getBucketFolder: function(date) {
      const year = date.getUTCFullYear();

      const monthInt = date.getUTCMonth() + 1;
      const monthStr = new String(monthInt).padStart(2, "0");

      const dayInt = date.getUTCDate();
      const dayStr = new String(dayInt).padStart(2, "0");

      return `${year}/${monthStr}/${dayStr}`;
    },
    getFileNameConfig: function(ticket = "", revision = "", fileName, date) {
      const maxFileNameLength = 160;
      const fileExtensionSeparatorIndex = fileName.lastIndexOf(".");
      const fileNameWithoutExtension = fileName.substring(
        0,
        fileExtensionSeparatorIndex
      );
      const fileExtension = fileName.substring(fileExtensionSeparatorIndex + 1);
      const epoch = "-" + date.valueOf();

      if (ticket) {
        ticket += "-";
      }

      if (revision) {
        revision += "-";
      }

      const trimFileNameLength =
        maxFileNameLength -
        ticket.length -
        revision.length -
        epoch.length -
        ("." + fileExtension).length;
      const trimmedFileName = fileNameWithoutExtension.substring(
        0,
        trimFileNameLength
      );

      const fullFileName =
        ticket + revision + trimmedFileName + epoch + "." + fileExtension;

      return {
        fullFileName,
        fileExtension
      };
    }
  }
};
